export const calculateTaxes = (taxes, nights, baseRate) => {
  let cityTourismTax = 0;
  let occupancyTax = 0;
  let vatGstTax = 0;

  taxes?.forEach((singleTax) => {
    if (
      singleTax.taxType === "cityTax" &&
      singleTax.taxAppliedPer === "night"
    ) {
      cityTourismTax += singleTax.amount * nights;
    }
    if (
      singleTax.taxType === "occupancyTax" &&
      singleTax.taxAppliedPer === "reservation"
    ) {
      occupancyTax += (baseRate * singleTax.amount) / 100;
    }
    if (
      singleTax.taxType === "vat" &&
      singleTax.taxAppliedPer === "reservation"
    ) {
      vatGstTax += (baseRate * singleTax.amount) / 100;
    }
  });

  return { cityTourismTax, occupancyTax, vatGstTax };
};
